"use client"

import { FileClock } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileClockIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileClockIcon = component(Icon)({ as: FileClock })
